import $ from "jquery";
import baseClass from "./base/base";

window.$ = $;
window.jQuery = $;
window.CKEDITOR_BASEPATH = "/ckeditor/libs/";

baseClass.OnLoadArrAdd(function () {
  setInterval(() => {
    const now = Date.now();
    for (const [url, entry] of Object.entries(window.__preloadedPages || {})) {
      if (!entry || now - entry.timestamp > entry.maxAge) {
        console.log("Interval delete: ", url);
        delete window.__preloadedPages[url];
      }
    }
  }, 60000);
});

baseClass.OnLoadArrAdd(function () {
  
  const title = document.title ?? "";

  history.replaceState(
    {
      info: {
        href: window.location.href
      },
      data: null,
      title: title
    },
    title,
    window.location.href
  );

});


window.addEventListener('popstate', function (event) {
  // console.log('popstatepopstatepopstatepopstatepopstatepopstate', event.state);
  if (event.state?.info != undefined)
  {

    if (!event.state?.data)
    {
    var tobj = {};
    tobj.href = event.state?.info?.href;
    baseClass.loadDataAjax(null, tobj);
    return;
    } else{

  baseClass.isPopState = true;
  // console.log('popstatepopstatepopstatepopstatepopstatepopstate', event.state?.info);

    }


  }

  
  
});